import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActiveProductService, Product } from '@edassist/api';
import { Subscription } from 'rxjs';
import { constants } from '@edassist/common';

@Component({
	selector: 'ea-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
	copyrightYear: number;
	activeProduct: number;
	constants = constants;
	showSiteMap = true;
	private readonly subscriptions = new Subscription();

	links = [
		{ href: 'https://www.brighthorizons.com/privacy', id: 'privacyPolicy', dataCy: 'footer-privacy-policy', text: 'Privacy Notice' },
		{ href: 'https://www.brighthorizons.com/privacy/cookie-notice', id: 'cookieNotice', dataCy: 'footer-cookie-notice', text: 'Cookie Notice' },
		{ href: 'https://www.brighthorizons.com/terms/terms-use', id: 'termsUse', dataCy: 'terms-use', text: 'Acceptable Use Policy' },
		{ href: 'https://www.brighthorizons.com/trademarks', id: 'trademarks', dataCy: 'footer-trademarks', text: 'Trademarks' }
	];

	constructor(private readonly activeProductService: ActiveProductService) {}

	ngOnInit(): void {
		const currentDate = new Date();
		this.copyrightYear = currentDate.getFullYear();

		this.subscriptions.add(
			this.activeProductService.activeProduct.subscribe((product: Product) => {
				this.activeProduct = product?.id;
				this.showSiteMap = !(this.activeProduct === constants.PRODUCTS.STUDENT_LOAN_SUPPORT.ID || this.activeProduct === constants.PRODUCTS.CLIENT_CUSTOM_PATHWAY.ID);
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
